"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemSearchScope = exports.SketchProvider = exports.ScreenType = exports.RiskLevel = exports.ProductTypeEnum = exports.PricingStatus = exports.PricingSearchScopeEnum = exports.PositionValidation = exports.PidDiagramDownloadResponseCodeEnum = exports.PidDiagramCheckStateResponseCodeEnum = exports.PidDiagramBuildResponseCodeEnum = exports.OperatingCaseResultTypeEnum = exports.MonthEnum = exports.MoistureLoadWindProtectionType = exports.MoistureLoadWarningEnum = exports.MoistureLoadVentilationFlowMode = exports.MoistureLoadTemperatureControl = exports.MoistureLoadSystemConfiguration = exports.MoistureLoadSiloContent = exports.MoistureLoadSearchScope = exports.MoistureLoadPropertySelectorType = exports.MoistureLoadPermissionLevel = exports.MoistureLoadOpeningAirVelocityMode = exports.MoistureLoadInfiltrationModel = exports.MoistureLoadHumidityControlType = exports.MoistureLoadHumidityControl = exports.MoistureLoadFuel = exports.MoistureLoadBuildingStructure = exports.MoistureLoadBuildingLocation = exports.MoistureLoadApplicationType = exports.MoistureLoadAirSource = exports.MoistureLoadActivityNearSurface = exports.MoistureLoadActivityLevel = exports.MoistureHeatLoadTypeEnum = exports.ImageUsage = exports.ImageFormat = exports.FlowSourceEnum = exports.FanProControlMode = exports.FanMotorProControlMode = exports.ErrorAndWarningType = exports.EnergyCostType = exports.DryCapModel = exports.DriveType = exports.DesignCaseTypeEnum = exports.ConfigStatusPropertyName = exports.ConfigStatusProduct = exports.ComponentCalculationType = exports.CaseType = exports.ArrangementEnum = exports.AirProperty = void 0;
exports.WiringDiagramDownloadResponseCodeEnum = exports.WiringDiagramCheckStateResponseCodeEnum = exports.WiringDiagramBuildResponseCodeEnum = exports.VariantDataType = exports.TotalCostOfOwnershipdSearchScope = exports.SystemTypeStatus = exports.SystemStatus = void 0;
/** Air property enum */
var AirProperty;
(function (AirProperty) {
    AirProperty["ABSOLUTE_PRESSURE"] = "ABSOLUTE_PRESSURE";
    AirProperty["DENSITY"] = "DENSITY";
    AirProperty["DEW_POINT_TEMPERATURE"] = "DEW_POINT_TEMPERATURE";
    AirProperty["HUMIDITY_RATIO"] = "HUMIDITY_RATIO";
    AirProperty["MASS_FLOW"] = "MASS_FLOW";
    AirProperty["RELATIVE_HUMIDITY"] = "RELATIVE_HUMIDITY";
    AirProperty["RELATIVE_PRESSURE"] = "RELATIVE_PRESSURE";
    AirProperty["TEMPERATURE"] = "TEMPERATURE";
    AirProperty["VOLUME_FLOW"] = "VOLUME_FLOW";
    AirProperty["WET_TEMPERATURE"] = "WET_TEMPERATURE";
})(AirProperty || (exports.AirProperty = AirProperty = {}));
/** Arrangement type enum */
var ArrangementEnum;
(function (ArrangementEnum) {
    ArrangementEnum["INLET_PRE_COIL_MIX_BLEND_COIL_ROTOR"] = "INLET_PRE_COIL_MIX_BLEND_COIL_ROTOR";
    ArrangementEnum["INLET_PRE_COIL_MIX_BLEND_COIL_ROTOR_POST_COIL"] = "INLET_PRE_COIL_MIX_BLEND_COIL_ROTOR_POST_COIL";
    ArrangementEnum["INLET_PRE_COIL_MIX_ROTOR"] = "INLET_PRE_COIL_MIX_ROTOR";
    ArrangementEnum["INLET_PRE_COIL_MIX_ROTOR_POST_COIL"] = "INLET_PRE_COIL_MIX_ROTOR_POST_COIL";
    ArrangementEnum["INLET_PRE_COIL_ROTOR"] = "INLET_PRE_COIL_ROTOR";
    ArrangementEnum["INLET_PRE_COIL_ROTOR_POST_COIL"] = "INLET_PRE_COIL_ROTOR_POST_COIL";
    ArrangementEnum["INLET_ROTOR"] = "INLET_ROTOR";
    ArrangementEnum["INLET_ROTOR_POST_COIL"] = "INLET_ROTOR_POST_COIL";
    ArrangementEnum["MIX_BLEND_COIL_ROTOR"] = "MIX_BLEND_COIL_ROTOR";
    ArrangementEnum["MIX_BLEND_COIL_ROTOR_POST_COIL"] = "MIX_BLEND_COIL_ROTOR_POST_COIL";
    ArrangementEnum["MIX_ROTOR"] = "MIX_ROTOR";
    ArrangementEnum["MIX_ROTOR_POST_COIL"] = "MIX_ROTOR_POST_COIL";
})(ArrangementEnum || (exports.ArrangementEnum = ArrangementEnum = {}));
/** Case type */
var CaseType;
(function (CaseType) {
    CaseType["BIN"] = "BIN";
    CaseType["DESIGN"] = "DESIGN";
    CaseType["ERP"] = "ERP";
    CaseType["EUROVENT"] = "EUROVENT";
    CaseType["RATING"] = "RATING";
})(CaseType || (exports.CaseType = CaseType = {}));
/** Component calculation type */
var ComponentCalculationType;
(function (ComponentCalculationType) {
    ComponentCalculationType["MAX_RESULT"] = "MAX_RESULT";
    ComponentCalculationType["SELECTION"] = "SELECTION";
    ComponentCalculationType["SYSTEM_SIMULATION"] = "SYSTEM_SIMULATION";
})(ComponentCalculationType || (exports.ComponentCalculationType = ComponentCalculationType = {}));
/** product code */
var ConfigStatusProduct;
(function (ConfigStatusProduct) {
    ConfigStatusProduct["DHS"] = "DHS";
    ConfigStatusProduct["DHU"] = "DHU";
    ConfigStatusProduct["DH_2"] = "DH_2";
    ConfigStatusProduct["EPX"] = "EPX";
    ConfigStatusProduct["HCU"] = "HCU";
    ConfigStatusProduct["SYS"] = "SYS";
})(ConfigStatusProduct || (exports.ConfigStatusProduct = ConfigStatusProduct = {}));
/** Property name */
var ConfigStatusPropertyName;
(function (ConfigStatusPropertyName) {
    ConfigStatusPropertyName["DHMODEL"] = "DHMODEL";
    ConfigStatusPropertyName["EPXSIZE"] = "EPXSIZE";
    ConfigStatusPropertyName["HUMMODEL"] = "HUMMODEL";
    ConfigStatusPropertyName["PRODUCTCODE"] = "PRODUCTCODE";
    ConfigStatusPropertyName["RANGETYPE"] = "RANGETYPE";
    ConfigStatusPropertyName["SIZE"] = "SIZE";
})(ConfigStatusPropertyName || (exports.ConfigStatusPropertyName = ConfigStatusPropertyName = {}));
/** Type of case. */
var DesignCaseTypeEnum;
(function (DesignCaseTypeEnum) {
    DesignCaseTypeEnum["COOLING"] = "COOLING";
    DesignCaseTypeEnum["DEHUMIDIFICATION"] = "DEHUMIDIFICATION";
    DesignCaseTypeEnum["HEATING"] = "HEATING";
    DesignCaseTypeEnum["HUMIDIFICATION"] = "HUMIDIFICATION";
})(DesignCaseTypeEnum || (exports.DesignCaseTypeEnum = DesignCaseTypeEnum = {}));
var DriveType;
(function (DriveType) {
    DriveType["BELT"] = "BELT";
    DriveType["DIRECT"] = "DIRECT";
})(DriveType || (exports.DriveType = DriveType = {}));
/** DryCap models */
var DryCapModel;
(function (DryCapModel) {
    DryCapModel["MCS_300"] = "MCS_300";
    DryCapModel["MCS_300_C"] = "MCS_300_C";
    DryCapModel["MC_150_X"] = "MC_150_X";
    DryCapModel["MC_150_Y"] = "MC_150_Y";
    DryCapModel["MG_50"] = "MG_50";
    DryCapModel["MG_90"] = "MG_90";
    DryCapModel["MH_270"] = "MH_270";
    DryCapModel["M_90_L"] = "M_90_L";
    DryCapModel["M_120_L"] = "M_120_L";
    DryCapModel["M_160_L"] = "M_160_L";
    DryCapModel["M_170_L"] = "M_170_L";
    DryCapModel["M_190_Y"] = "M_190_Y";
    DryCapModel["M_200_L"] = "M_200_L";
    DryCapModel["M_210_X"] = "M_210_X";
})(DryCapModel || (exports.DryCapModel = DryCapModel = {}));
/** Energy Cost Type */
var EnergyCostType;
(function (EnergyCostType) {
    EnergyCostType["COOLING_WATER_COST"] = "COOLING_WATER_COST";
    EnergyCostType["ELECTRICITY_COST"] = "ELECTRICITY_COST";
    EnergyCostType["GAS_COST"] = "GAS_COST";
    EnergyCostType["HEATING_WATER_COST"] = "HEATING_WATER_COST";
    EnergyCostType["HUMIDIFIER_WATER_COST"] = "HUMIDIFIER_WATER_COST";
    EnergyCostType["NO_COST"] = "NO_COST";
    EnergyCostType["SEWAGE_COST"] = "SEWAGE_COST";
    EnergyCostType["STEAM_COST"] = "STEAM_COST";
    EnergyCostType["WATER_COST"] = "WATER_COST";
})(EnergyCostType || (exports.EnergyCostType = EnergyCostType = {}));
/** Issue Types */
var ErrorAndWarningType;
(function (ErrorAndWarningType) {
    ErrorAndWarningType["PROPERTY_DIFFERENT_STANDARD_TRANSLATIONS"] = "PROPERTY_DIFFERENT_STANDARD_TRANSLATIONS";
    ErrorAndWarningType["PROPERTY_MISSING_DEFAULT_LANGUAGE_STANDARD_TRANSLATIONS"] = "PROPERTY_MISSING_DEFAULT_LANGUAGE_STANDARD_TRANSLATIONS";
    ErrorAndWarningType["PROPERTY_MULTIPLE_STANDARD_TRANSLATION"] = "PROPERTY_MULTIPLE_STANDARD_TRANSLATION";
    ErrorAndWarningType["PROPERTY_NON_STANDARD_TRANSLATION_WARNING"] = "PROPERTY_NON_STANDARD_TRANSLATION_WARNING";
    ErrorAndWarningType["PROPERTY_TYPE_WARNING"] = "PROPERTY_TYPE_WARNING";
    ErrorAndWarningType["PROPERTY_UNNECESSARY_TRANSLATION"] = "PROPERTY_UNNECESSARY_TRANSLATION";
    ErrorAndWarningType["PROPERTY_VALUE_DIFFERENT_STANDARD_TRANSLATIONS"] = "PROPERTY_VALUE_DIFFERENT_STANDARD_TRANSLATIONS";
    ErrorAndWarningType["PROPERTY_VALUE_MISSING_DEFAULT_LANGUAGE_STANDARD_TRANSLATIONS"] = "PROPERTY_VALUE_MISSING_DEFAULT_LANGUAGE_STANDARD_TRANSLATIONS";
    ErrorAndWarningType["PROPERTY_VALUE_MISSING_STANDARD_TRANSLATIONS"] = "PROPERTY_VALUE_MISSING_STANDARD_TRANSLATIONS";
    ErrorAndWarningType["PROPERTY_VALUE_MULTIPLE_STANDARD_TRANSLATION"] = "PROPERTY_VALUE_MULTIPLE_STANDARD_TRANSLATION";
    ErrorAndWarningType["PROPERTY_VALUE_UNNECESSARY_TRANSLATION"] = "PROPERTY_VALUE_UNNECESSARY_TRANSLATION";
    ErrorAndWarningType["PROPERY_VALUE_NON_STANDARD_TRANSLATION_WARNING"] = "PROPERY_VALUE_NON_STANDARD_TRANSLATION_WARNING";
})(ErrorAndWarningType || (exports.ErrorAndWarningType = ErrorAndWarningType = {}));
var FanMotorProControlMode;
(function (FanMotorProControlMode) {
    FanMotorProControlMode["MAXIMIZE"] = "MAXIMIZE";
    FanMotorProControlMode["MODULATE"] = "MODULATE";
})(FanMotorProControlMode || (exports.FanMotorProControlMode = FanMotorProControlMode = {}));
var FanProControlMode;
(function (FanProControlMode) {
    FanProControlMode["MAXIMIZE"] = "MAXIMIZE";
    FanProControlMode["MODULATE"] = "MODULATE";
})(FanProControlMode || (exports.FanProControlMode = FanProControlMode = {}));
/** Source of flow. */
var FlowSourceEnum;
(function (FlowSourceEnum) {
    FlowSourceEnum["MAKE_UP_FLOW"] = "MAKE_UP_FLOW";
    FlowSourceEnum["MAX_COOLING_FLOW"] = "MAX_COOLING_FLOW";
    FlowSourceEnum["MAX_DEHUMIDIFICATION_FLOW"] = "MAX_DEHUMIDIFICATION_FLOW";
    FlowSourceEnum["MAX_EXCHANGES"] = "MAX_EXCHANGES";
    FlowSourceEnum["MAX_HEATING_FLOW"] = "MAX_HEATING_FLOW";
    FlowSourceEnum["MAX_HUMIDIFICATION_FLOW"] = "MAX_HUMIDIFICATION_FLOW";
    FlowSourceEnum["MIN_COOLING_FLOW"] = "MIN_COOLING_FLOW";
    FlowSourceEnum["MIN_DEHUMIDIFICATION_FLOW"] = "MIN_DEHUMIDIFICATION_FLOW";
    FlowSourceEnum["MIN_EXCHANGES"] = "MIN_EXCHANGES";
    FlowSourceEnum["MIN_HEATING_FLOW"] = "MIN_HEATING_FLOW";
    FlowSourceEnum["MIN_HUMIDIFICATION_FLOW"] = "MIN_HUMIDIFICATION_FLOW";
    FlowSourceEnum["OK_GENERATED"] = "OK_GENERATED";
})(FlowSourceEnum || (exports.FlowSourceEnum = FlowSourceEnum = {}));
/** Image data format */
var ImageFormat;
(function (ImageFormat) {
    ImageFormat["AVIF"] = "AVIF";
    ImageFormat["DWG"] = "DWG";
    ImageFormat["DXF_2_D"] = "DXF_2_D";
    ImageFormat["DXF_3_D"] = "DXF_3_D";
    ImageFormat["JPG"] = "JPG";
    ImageFormat["PNG"] = "PNG";
    ImageFormat["SVG"] = "SVG";
    ImageFormat["X_3_D"] = "X_3_D";
})(ImageFormat || (exports.ImageFormat = ImageFormat = {}));
/** Case id */
var ImageUsage;
(function (ImageUsage) {
    ImageUsage["ANY"] = "ANY";
    ImageUsage["DESIGN_PERF_PARAMS"] = "DESIGN_PERF_PARAMS";
    ImageUsage["DIAGRAM_SYMBOL"] = "DIAGRAM_SYMBOL";
    ImageUsage["MECHANICAL_SKETCH"] = "MECHANICAL_SKETCH";
    ImageUsage["NEW_SYSTEM_WIZARD"] = "NEW_SYSTEM_WIZARD";
    ImageUsage["REPORT"] = "REPORT";
    ImageUsage["SKETCH_SHAPE"] = "SKETCH_SHAPE";
    ImageUsage["SPECIFICATIONS"] = "SPECIFICATIONS";
})(ImageUsage || (exports.ImageUsage = ImageUsage = {}));
/** Moisture / heat load types. */
var MoistureHeatLoadTypeEnum;
(function (MoistureHeatLoadTypeEnum) {
    MoistureHeatLoadTypeEnum["EMISSION_FROM_COMBUSTION"] = "EMISSION_FROM_COMBUSTION";
    MoistureHeatLoadTypeEnum["EMISSION_FROM_PEOPLE"] = "EMISSION_FROM_PEOPLE";
    MoistureHeatLoadTypeEnum["EVAPORATION_FROM_MATERIALS"] = "EVAPORATION_FROM_MATERIALS";
    MoistureHeatLoadTypeEnum["EVAPORATION_OF_WATER"] = "EVAPORATION_OF_WATER";
    MoistureHeatLoadTypeEnum["HEAT_TRANSMISSION"] = "HEAT_TRANSMISSION";
    MoistureHeatLoadTypeEnum["INTENTIONAL_VENTILATION"] = "INTENTIONAL_VENTILATION";
    MoistureHeatLoadTypeEnum["OPENING"] = "OPENING";
    MoistureHeatLoadTypeEnum["OPEN_DOOR"] = "OPEN_DOOR";
    MoistureHeatLoadTypeEnum["STATIC_HEAT_LOAD"] = "STATIC_HEAT_LOAD";
    MoistureHeatLoadTypeEnum["STATIC_MOISTURE_LOAD"] = "STATIC_MOISTURE_LOAD";
    MoistureHeatLoadTypeEnum["UNINTENDED_VENTILATION"] = "UNINTENDED_VENTILATION";
})(MoistureHeatLoadTypeEnum || (exports.MoistureHeatLoadTypeEnum = MoistureHeatLoadTypeEnum = {}));
/** How hard people in the building are working. Determines moisture and heat emitted per person. */
var MoistureLoadActivityLevel;
(function (MoistureLoadActivityLevel) {
    MoistureLoadActivityLevel["HIGH"] = "HIGH";
    MoistureLoadActivityLevel["LOW"] = "LOW";
    MoistureLoadActivityLevel["MEDIUM"] = "MEDIUM";
    MoistureLoadActivityLevel["NA"] = "NA";
})(MoistureLoadActivityLevel || (exports.MoistureLoadActivityLevel = MoistureLoadActivityLevel = {}));
/** How still or turbulent the air is above an evaporating water surface. */
var MoistureLoadActivityNearSurface;
(function (MoistureLoadActivityNearSurface) {
    MoistureLoadActivityNearSurface["AVERAGE"] = "AVERAGE";
    MoistureLoadActivityNearSurface["CALM"] = "CALM";
    MoistureLoadActivityNearSurface["NA"] = "NA";
    MoistureLoadActivityNearSurface["TURBULENT"] = "TURBULENT";
})(MoistureLoadActivityNearSurface || (exports.MoistureLoadActivityNearSurface = MoistureLoadActivityNearSurface = {}));
/** Where air entering the room along a given path comes from. */
var MoistureLoadAirSource;
(function (MoistureLoadAirSource) {
    MoistureLoadAirSource["MANUAL"] = "MANUAL";
    MoistureLoadAirSource["NA"] = "NA";
    MoistureLoadAirSource["OUTDOOR"] = "OUTDOOR";
    MoistureLoadAirSource["SURROUNDING"] = "SURROUNDING";
})(MoistureLoadAirSource || (exports.MoistureLoadAirSource = MoistureLoadAirSource = {}));
/** The kind of building or installation a moisture load is calculated for. Determines which building structures, system configurations and loads are offered. */
var MoistureLoadApplicationType;
(function (MoistureLoadApplicationType) {
    MoistureLoadApplicationType["BRIDGE"] = "BRIDGE";
    MoistureLoadApplicationType["CAVERN"] = "CAVERN";
    MoistureLoadApplicationType["DECOMMISIONED_BUILDING"] = "DECOMMISIONED_BUILDING";
    MoistureLoadApplicationType["GENERAL"] = "GENERAL";
    MoistureLoadApplicationType["HYDRO_ELECTRIC_POWER_PLANT"] = "HYDRO_ELECTRIC_POWER_PLANT";
    MoistureLoadApplicationType["ICE_RINK"] = "ICE_RINK";
    MoistureLoadApplicationType["MILITARY_STORE"] = "MILITARY_STORE";
    MoistureLoadApplicationType["MUSEUM"] = "MUSEUM";
    MoistureLoadApplicationType["SILO"] = "SILO";
    MoistureLoadApplicationType["STORED_BULK_POWDER"] = "STORED_BULK_POWDER";
    MoistureLoadApplicationType["STORED_PAPER_PRODUCTS"] = "STORED_PAPER_PRODUCTS";
    MoistureLoadApplicationType["STORED_STEEL_PRODUCTS"] = "STORED_STEEL_PRODUCTS";
    MoistureLoadApplicationType["SWIMMING_POOL"] = "SWIMMING_POOL";
    MoistureLoadApplicationType["TIMBER_WARE_HOUSE"] = "TIMBER_WARE_HOUSE";
    MoistureLoadApplicationType["WATERWORKS"] = "WATERWORKS";
})(MoistureLoadApplicationType || (exports.MoistureLoadApplicationType = MoistureLoadApplicationType = {}));
/** Whether the building is exposed to outdoor climate or stands inside another building. */
var MoistureLoadBuildingLocation;
(function (MoistureLoadBuildingLocation) {
    MoistureLoadBuildingLocation["INSIDE_ANOTHER_BUILDING"] = "INSIDE_ANOTHER_BUILDING";
    MoistureLoadBuildingLocation["OUTDOOR"] = "OUTDOOR";
})(MoistureLoadBuildingLocation || (exports.MoistureLoadBuildingLocation = MoistureLoadBuildingLocation = {}));
/** How the building envelope is built. Determines the default U-values and leakage coefficient. */
var MoistureLoadBuildingStructure;
(function (MoistureLoadBuildingStructure) {
    MoistureLoadBuildingStructure["BRICK"] = "BRICK";
    MoistureLoadBuildingStructure["BRIDGE"] = "BRIDGE";
    MoistureLoadBuildingStructure["CAVERN"] = "CAVERN";
    MoistureLoadBuildingStructure["CONCRETE"] = "CONCRETE";
    MoistureLoadBuildingStructure["CORRUGATED_STEEL_SHEET"] = "CORRUGATED_STEEL_SHEET";
    MoistureLoadBuildingStructure["INSULATED_STEEL_SHEET"] = "INSULATED_STEEL_SHEET";
    MoistureLoadBuildingStructure["INSULATED_WOOD"] = "INSULATED_WOOD";
    MoistureLoadBuildingStructure["NA"] = "NA";
    MoistureLoadBuildingStructure["PLASTIC_TENT"] = "PLASTIC_TENT";
    MoistureLoadBuildingStructure["SILO"] = "SILO";
    MoistureLoadBuildingStructure["UNINSULATED_WOOD"] = "UNINSULATED_WOOD";
})(MoistureLoadBuildingStructure || (exports.MoistureLoadBuildingStructure = MoistureLoadBuildingStructure = {}));
/** The fuel burned inside the building. Determines water vapour and energy released per unit burned. */
var MoistureLoadFuel;
(function (MoistureLoadFuel) {
    MoistureLoadFuel["DIESEL"] = "DIESEL";
    MoistureLoadFuel["GASOL_PROPANE"] = "GASOL_PROPANE";
    MoistureLoadFuel["NA"] = "NA";
    MoistureLoadFuel["NATURAL_GAS_METHANE"] = "NATURAL_GAS_METHANE";
    MoistureLoadFuel["PETROL"] = "PETROL";
})(MoistureLoadFuel || (exports.MoistureLoadFuel = MoistureLoadFuel = {}));
/** How the room humidity is controlled: not at all, to a minimum, a maximum, a constant, or a range. */
var MoistureLoadHumidityControl;
(function (MoistureLoadHumidityControl) {
    MoistureLoadHumidityControl["CONSTANT_HUMIDITY"] = "CONSTANT_HUMIDITY";
    MoistureLoadHumidityControl["IN_RANGE"] = "IN_RANGE";
    MoistureLoadHumidityControl["MAX_HUMIDITY"] = "MAX_HUMIDITY";
    MoistureLoadHumidityControl["MIN_HUMIDITY"] = "MIN_HUMIDITY";
    MoistureLoadHumidityControl["NONE"] = "NONE";
})(MoistureLoadHumidityControl || (exports.MoistureLoadHumidityControl = MoistureLoadHumidityControl = {}));
/** Which humidity measure the room control uses: absolute, relative, dew point, or floating dew point. */
var MoistureLoadHumidityControlType;
(function (MoistureLoadHumidityControlType) {
    MoistureLoadHumidityControlType["ABSOLUTE_HUMIDITY"] = "ABSOLUTE_HUMIDITY";
    MoistureLoadHumidityControlType["DEW_POINT"] = "DEW_POINT";
    MoistureLoadHumidityControlType["FLOATING_DEW_POINT"] = "FLOATING_DEW_POINT";
    MoistureLoadHumidityControlType["NONE"] = "NONE";
    MoistureLoadHumidityControlType["RELATIVE_HUMIDITY"] = "RELATIVE_HUMIDITY";
})(MoistureLoadHumidityControlType || (exports.MoistureLoadHumidityControlType = MoistureLoadHumidityControlType = {}));
/** How unintended air infiltration is calculated: not at all, from air changes, or from wind force. */
var MoistureLoadInfiltrationModel;
(function (MoistureLoadInfiltrationModel) {
    MoistureLoadInfiltrationModel["AIR_CHANGES"] = "AIR_CHANGES";
    MoistureLoadInfiltrationModel["NA"] = "NA";
    MoistureLoadInfiltrationModel["WINDFORCE"] = "WINDFORCE";
})(MoistureLoadInfiltrationModel || (exports.MoistureLoadInfiltrationModel = MoistureLoadInfiltrationModel = {}));
/** How the air velocity through a large opening is determined: entered directly, derived from the wind speed by a coefficient, or derived and then capped. */
var MoistureLoadOpeningAirVelocityMode;
(function (MoistureLoadOpeningAirVelocityMode) {
    MoistureLoadOpeningAirVelocityMode["COEFFICIENT"] = "COEFFICIENT";
    MoistureLoadOpeningAirVelocityMode["COEFFICIENT_WITH_MAX_VELOCITY"] = "COEFFICIENT_WITH_MAX_VELOCITY";
    MoistureLoadOpeningAirVelocityMode["MANUAL_VELOCITY"] = "MANUAL_VELOCITY";
    MoistureLoadOpeningAirVelocityMode["NA"] = "NA";
})(MoistureLoadOpeningAirVelocityMode || (exports.MoistureLoadOpeningAirVelocityMode = MoistureLoadOpeningAirVelocityMode = {}));
/** How much of the moisture load tool the user may see and edit. */
var MoistureLoadPermissionLevel;
(function (MoistureLoadPermissionLevel) {
    MoistureLoadPermissionLevel["ADVANCED"] = "ADVANCED";
    MoistureLoadPermissionLevel["BASIC"] = "BASIC";
    MoistureLoadPermissionLevel["SUPPORT"] = "SUPPORT";
})(MoistureLoadPermissionLevel || (exports.MoistureLoadPermissionLevel = MoistureLoadPermissionLevel = {}));
/** Property selector type */
var MoistureLoadPropertySelectorType;
(function (MoistureLoadPropertySelectorType) {
    MoistureLoadPropertySelectorType["AMOUNT"] = "AMOUNT";
    MoistureLoadPropertySelectorType["CHECK_BOX"] = "CHECK_BOX";
    MoistureLoadPropertySelectorType["DISCRETE"] = "DISCRETE";
})(MoistureLoadPropertySelectorType || (exports.MoistureLoadPropertySelectorType = MoistureLoadPropertySelectorType = {}));
/** Search scope */
var MoistureLoadSearchScope;
(function (MoistureLoadSearchScope) {
    MoistureLoadSearchScope["ALL"] = "ALL";
    MoistureLoadSearchScope["MY"] = "MY";
})(MoistureLoadSearchScope || (exports.MoistureLoadSearchScope = MoistureLoadSearchScope = {}));
/** What a silo stores. */
var MoistureLoadSiloContent;
(function (MoistureLoadSiloContent) {
    MoistureLoadSiloContent["FLOUR"] = "FLOUR";
    MoistureLoadSiloContent["NA"] = "NA";
    MoistureLoadSiloContent["OTHER"] = "OTHER";
    MoistureLoadSiloContent["PLASTIC_GRANULES"] = "PLASTIC_GRANULES";
    MoistureLoadSiloContent["PLASTIC_POWDER"] = "PLASTIC_POWDER";
    MoistureLoadSiloContent["SUGAR"] = "SUGAR";
})(MoistureLoadSiloContent || (exports.MoistureLoadSiloContent = MoistureLoadSiloContent = {}));
/** How the system exchanges air with its surroundings: closed, closed with make-up air, or open. */
var MoistureLoadSystemConfiguration;
(function (MoistureLoadSystemConfiguration) {
    MoistureLoadSystemConfiguration["CLOSED"] = "CLOSED";
    MoistureLoadSystemConfiguration["CLOSED_WITH_MAKE_UP"] = "CLOSED_WITH_MAKE_UP";
    MoistureLoadSystemConfiguration["OPEN"] = "OPEN";
})(MoistureLoadSystemConfiguration || (exports.MoistureLoadSystemConfiguration = MoistureLoadSystemConfiguration = {}));
/** How the room temperature is controlled: not at all, to a minimum, a maximum, a constant, or a range. */
var MoistureLoadTemperatureControl;
(function (MoistureLoadTemperatureControl) {
    MoistureLoadTemperatureControl["CONSTANT_TEMP"] = "CONSTANT_TEMP";
    MoistureLoadTemperatureControl["IN_RANGE"] = "IN_RANGE";
    MoistureLoadTemperatureControl["MAX_TEMP"] = "MAX_TEMP";
    MoistureLoadTemperatureControl["MIN_TEMP"] = "MIN_TEMP";
    MoistureLoadTemperatureControl["NONE"] = "NONE";
})(MoistureLoadTemperatureControl || (exports.MoistureLoadTemperatureControl = MoistureLoadTemperatureControl = {}));
/** Whether the intentional ventilation flow is given as a coefficient or as an explicit flow. */
var MoistureLoadVentilationFlowMode;
(function (MoistureLoadVentilationFlowMode) {
    MoistureLoadVentilationFlowMode["MANUAL"] = "MANUAL";
    MoistureLoadVentilationFlowMode["NA"] = "NA";
    MoistureLoadVentilationFlowMode["VENTILATION_FLOW_COEFFICIENT"] = "VENTILATION_FLOW_COEFFICIENT";
})(MoistureLoadVentilationFlowMode || (exports.MoistureLoadVentilationFlowMode = MoistureLoadVentilationFlowMode = {}));
/** Which type of warning?. */
var MoistureLoadWarningEnum;
(function (MoistureLoadWarningEnum) {
    MoistureLoadWarningEnum["INDOOR_HUMIDITY_AT_MAX"] = "INDOOR_HUMIDITY_AT_MAX";
    MoistureLoadWarningEnum["INDOOR_HUMIDITY_AT_MIN"] = "INDOOR_HUMIDITY_AT_MIN";
    MoistureLoadWarningEnum["INDOOR_TEMP_AT_MAX"] = "INDOOR_TEMP_AT_MAX";
    MoistureLoadWarningEnum["INDOOR_TEMP_AT_MIN"] = "INDOOR_TEMP_AT_MIN";
    MoistureLoadWarningEnum["SOLUTION_NOT_WITHIN_TOLERANCE"] = "SOLUTION_NOT_WITHIN_TOLERANCE";
    MoistureLoadWarningEnum["SYSTEM_TARGET_HUMIDITY_ABOVE_SATURATION"] = "SYSTEM_TARGET_HUMIDITY_ABOVE_SATURATION";
    MoistureLoadWarningEnum["SYSTEM_TARGET_HUMIDITY_BELOW_MIN"] = "SYSTEM_TARGET_HUMIDITY_BELOW_MIN";
    MoistureLoadWarningEnum["SYSTEM_TARGET_TEMP_ABOVE_MAX_HEATING"] = "SYSTEM_TARGET_TEMP_ABOVE_MAX_HEATING";
    MoistureLoadWarningEnum["SYSTEM_TARGET_TEMP_BELOW_MIN_COOLING"] = "SYSTEM_TARGET_TEMP_BELOW_MIN_COOLING";
})(MoistureLoadWarningEnum || (exports.MoistureLoadWarningEnum = MoistureLoadWarningEnum = {}));
/** How sheltered the building is from wind. Scales the wind force infiltration. */
var MoistureLoadWindProtectionType;
(function (MoistureLoadWindProtectionType) {
    MoistureLoadWindProtectionType["CERTAIN_PROTECTION"] = "CERTAIN_PROTECTION";
    MoistureLoadWindProtectionType["CITY"] = "CITY";
    MoistureLoadWindProtectionType["FULL_PROTECTION"] = "FULL_PROTECTION";
    MoistureLoadWindProtectionType["NA"] = "NA";
    MoistureLoadWindProtectionType["NO_PROTECTION"] = "NO_PROTECTION";
    MoistureLoadWindProtectionType["SUBURB"] = "SUBURB";
})(MoistureLoadWindProtectionType || (exports.MoistureLoadWindProtectionType = MoistureLoadWindProtectionType = {}));
var MonthEnum;
(function (MonthEnum) {
    MonthEnum["APRIL"] = "APRIL";
    MonthEnum["AUGUST"] = "AUGUST";
    MonthEnum["DECEMBER"] = "DECEMBER";
    MonthEnum["FEBRUARY"] = "FEBRUARY";
    MonthEnum["JANUARY"] = "JANUARY";
    MonthEnum["JULY"] = "JULY";
    MonthEnum["JUNE"] = "JUNE";
    MonthEnum["MARCH"] = "MARCH";
    MonthEnum["MAY"] = "MAY";
    MonthEnum["NOVEMBER"] = "NOVEMBER";
    MonthEnum["OCTOBER"] = "OCTOBER";
    MonthEnum["SEPTEMBER"] = "SEPTEMBER";
})(MonthEnum || (exports.MonthEnum = MonthEnum = {}));
var OperatingCaseResultTypeEnum;
(function (OperatingCaseResultTypeEnum) {
    OperatingCaseResultTypeEnum["AVERAGE"] = "AVERAGE";
    OperatingCaseResultTypeEnum["DESIGN"] = "DESIGN";
    OperatingCaseResultTypeEnum["NORMAL"] = "NORMAL";
})(OperatingCaseResultTypeEnum || (exports.OperatingCaseResultTypeEnum = OperatingCaseResultTypeEnum = {}));
/** Response code from build request */
var PidDiagramBuildResponseCodeEnum;
(function (PidDiagramBuildResponseCodeEnum) {
    PidDiagramBuildResponseCodeEnum["ALREADY_BUILDING"] = "ALREADY_BUILDING";
    PidDiagramBuildResponseCodeEnum["BUILDING"] = "BUILDING";
    PidDiagramBuildResponseCodeEnum["EXCEPTION"] = "EXCEPTION";
    PidDiagramBuildResponseCodeEnum["INVALID_GENESYS_ID"] = "INVALID_GENESYS_ID";
    PidDiagramBuildResponseCodeEnum["INVALID_USER"] = "INVALID_USER";
    PidDiagramBuildResponseCodeEnum["NOT_LOCKED"] = "NOT_LOCKED";
    PidDiagramBuildResponseCodeEnum["SERVER_ERROR"] = "SERVER_ERROR";
    PidDiagramBuildResponseCodeEnum["SYSTEM_NOT_SUPPORTED"] = "SYSTEM_NOT_SUPPORTED";
    PidDiagramBuildResponseCodeEnum["UNABLE_TO_PARSE"] = "UNABLE_TO_PARSE";
    PidDiagramBuildResponseCodeEnum["UNAUTHORIZED"] = "UNAUTHORIZED";
    PidDiagramBuildResponseCodeEnum["UNSPECIFIED_ERROR"] = "UNSPECIFIED_ERROR";
})(PidDiagramBuildResponseCodeEnum || (exports.PidDiagramBuildResponseCodeEnum = PidDiagramBuildResponseCodeEnum = {}));
/** Response code from check state request */
var PidDiagramCheckStateResponseCodeEnum;
(function (PidDiagramCheckStateResponseCodeEnum) {
    PidDiagramCheckStateResponseCodeEnum["BUILDING"] = "BUILDING";
    PidDiagramCheckStateResponseCodeEnum["BUILT"] = "BUILT";
    PidDiagramCheckStateResponseCodeEnum["CUSTOM_ERROR"] = "CUSTOM_ERROR";
    PidDiagramCheckStateResponseCodeEnum["EXCEPTION"] = "EXCEPTION";
    PidDiagramCheckStateResponseCodeEnum["INVALID_GENESYS_ID"] = "INVALID_GENESYS_ID";
    PidDiagramCheckStateResponseCodeEnum["NOT_DESIGNED"] = "NOT_DESIGNED";
    PidDiagramCheckStateResponseCodeEnum["SERVER_ERROR"] = "SERVER_ERROR";
    PidDiagramCheckStateResponseCodeEnum["UNAUTHORIZED"] = "UNAUTHORIZED";
    PidDiagramCheckStateResponseCodeEnum["UNSPECIFIED_ERROR"] = "UNSPECIFIED_ERROR";
})(PidDiagramCheckStateResponseCodeEnum || (exports.PidDiagramCheckStateResponseCodeEnum = PidDiagramCheckStateResponseCodeEnum = {}));
/** Response code from download request */
var PidDiagramDownloadResponseCodeEnum;
(function (PidDiagramDownloadResponseCodeEnum) {
    PidDiagramDownloadResponseCodeEnum["EXCEPTION"] = "EXCEPTION";
    PidDiagramDownloadResponseCodeEnum["INVALID_GENESYS_ID"] = "INVALID_GENESYS_ID";
    PidDiagramDownloadResponseCodeEnum["NOT_FOUND"] = "NOT_FOUND";
    PidDiagramDownloadResponseCodeEnum["OK"] = "OK";
    PidDiagramDownloadResponseCodeEnum["SERVER_ERROR"] = "SERVER_ERROR";
    PidDiagramDownloadResponseCodeEnum["UNAUTHORIZED"] = "UNAUTHORIZED";
    PidDiagramDownloadResponseCodeEnum["UNSPECIFIED_ERROR"] = "UNSPECIFIED_ERROR";
})(PidDiagramDownloadResponseCodeEnum || (exports.PidDiagramDownloadResponseCodeEnum = PidDiagramDownloadResponseCodeEnum = {}));
/** Position validation */
var PositionValidation;
(function (PositionValidation) {
    PositionValidation["NONE"] = "NONE";
    PositionValidation["PLACEMENT"] = "PLACEMENT";
    PositionValidation["SEQUENCE"] = "SEQUENCE";
})(PositionValidation || (exports.PositionValidation = PositionValidation = {}));
/** Search scope */
var PricingSearchScopeEnum;
(function (PricingSearchScopeEnum) {
    PricingSearchScopeEnum["ALL"] = "ALL";
    PricingSearchScopeEnum["MY"] = "MY";
})(PricingSearchScopeEnum || (exports.PricingSearchScopeEnum = PricingSearchScopeEnum = {}));
/** Pricing status */
var PricingStatus;
(function (PricingStatus) {
    PricingStatus["CREATED"] = "CREATED";
    PricingStatus["LOCKED"] = "LOCKED";
})(PricingStatus || (exports.PricingStatus = PricingStatus = {}));
/** Product Type */
var ProductTypeEnum;
(function (ProductTypeEnum) {
    ProductTypeEnum["ACCESSORY"] = "ACCESSORY";
    ProductTypeEnum["CASING"] = "CASING";
    ProductTypeEnum["CASING_TEMPLATE"] = "CASING_TEMPLATE";
    ProductTypeEnum["FUNCTION"] = "FUNCTION";
    ProductTypeEnum["M_COMPARE"] = "M_COMPARE";
    ProductTypeEnum["SYSTEM"] = "SYSTEM";
    ProductTypeEnum["WIZARD"] = "WIZARD";
})(ProductTypeEnum || (exports.ProductTypeEnum = ProductTypeEnum = {}));
/** Risk Level types */
var RiskLevel;
(function (RiskLevel) {
    RiskLevel["HIGH"] = "HIGH";
    RiskLevel["LOW"] = "LOW";
    RiskLevel["NONE"] = "NONE";
})(RiskLevel || (exports.RiskLevel = RiskLevel = {}));
/** Screen Type */
var ScreenType;
(function (ScreenType) {
    ScreenType["ADJUST_PRICE"] = "ADJUST_PRICE";
    ScreenType["CLIMATIX_CONTROL_FILE"] = "CLIMATIX_CONTROL_FILE";
    ScreenType["CONDENSATION_ANALYSIS"] = "CONDENSATION_ANALYSIS";
    ScreenType["DATA_CENTER_EDITOR"] = "DATA_CENTER_EDITOR";
    ScreenType["ENERGY"] = "ENERGY";
    ScreenType["MECHANICAL_SKETCH"] = "MECHANICAL_SKETCH";
    ScreenType["MULTIPLE_SYSTEMS_EDITOR"] = "MULTIPLE_SYSTEMS_EDITOR";
    ScreenType["M_COMPARE"] = "M_COMPARE";
    ScreenType["OPERATING_CASES"] = "OPERATING_CASES";
    ScreenType["PID_DIAGRAM"] = "PID_DIAGRAM";
    ScreenType["PROPERTY_GROUP"] = "PROPERTY_GROUP";
    ScreenType["PSYCHROMETRICS_CHART"] = "PSYCHROMETRICS_CHART";
    ScreenType["REVIT_BUILDER"] = "REVIT_BUILDER";
    ScreenType["SERVICE_CALCULATION"] = "SERVICE_CALCULATION";
    ScreenType["SOLID_CONTACT_BUILDER"] = "SOLID_CONTACT_BUILDER";
    ScreenType["SYSTEM_ACCESSORIES"] = "SYSTEM_ACCESSORIES";
    ScreenType["SYSTEM_DIAGRAM"] = "SYSTEM_DIAGRAM";
    ScreenType["SYSTEM_DOCUMENTS"] = "SYSTEM_DOCUMENTS";
    ScreenType["SYSTEM_PRINTOUT"] = "SYSTEM_PRINTOUT";
    ScreenType["SYSTEM_SIZE"] = "SYSTEM_SIZE";
    ScreenType["TOTAL_COST_OF_OWNERSHIP"] = "TOTAL_COST_OF_OWNERSHIP";
    ScreenType["WIRING_DIAGRAM"] = "WIRING_DIAGRAM";
})(ScreenType || (exports.ScreenType = ScreenType = {}));
/** Mechanical Sketch provider */
var SketchProvider;
(function (SketchProvider) {
    SketchProvider["DUMMY"] = "DUMMY";
    SketchProvider["SOLID_CONTACT"] = "SOLID_CONTACT";
    SketchProvider["STATIC_IMAGE"] = "STATIC_IMAGE";
})(SketchProvider || (exports.SketchProvider = SketchProvider = {}));
/** Search scope */
var SystemSearchScope;
(function (SystemSearchScope) {
    SystemSearchScope["ALL"] = "ALL";
    SystemSearchScope["MY"] = "MY";
})(SystemSearchScope || (exports.SystemSearchScope = SystemSearchScope = {}));
/** System Status */
var SystemStatus;
(function (SystemStatus) {
    SystemStatus["AUTO_CASES_FAILED"] = "AUTO_CASES_FAILED";
    SystemStatus["AUTO_CASES_SUCCESS"] = "AUTO_CASES_SUCCESS";
    SystemStatus["AUTO_COMPONENTS_FAILED"] = "AUTO_COMPONENTS_FAILED";
    SystemStatus["AUTO_COMPONENTS_SUCCESS"] = "AUTO_COMPONENTS_SUCCESS";
    SystemStatus["CONFIGURE_SYSTEM_FAILED"] = "CONFIGURE_SYSTEM_FAILED";
    SystemStatus["CONFIGURE_SYSTEM_SUCCESS"] = "CONFIGURE_SYSTEM_SUCCESS";
    SystemStatus["CREATED"] = "CREATED";
    SystemStatus["DESIGN_CALCULATION_FAILED"] = "DESIGN_CALCULATION_FAILED";
    SystemStatus["DESIGN_CALCULATION_SUCCESS"] = "DESIGN_CALCULATION_SUCCESS";
    SystemStatus["ENERGY_CALCULATION_FAILED"] = "ENERGY_CALCULATION_FAILED";
    SystemStatus["ENERGY_CALCULATION_PENDING"] = "ENERGY_CALCULATION_PENDING";
    SystemStatus["ENERGY_CALCULATION_SUCCESS"] = "ENERGY_CALCULATION_SUCCESS";
    SystemStatus["GENERATE_CASINGS_FAILED"] = "GENERATE_CASINGS_FAILED";
    SystemStatus["GENERATE_CASINGS_SUCCESS"] = "GENERATE_CASINGS_SUCCESS";
    SystemStatus["LOCK_FAILED"] = "LOCK_FAILED";
    SystemStatus["LOCK_SUCCESS"] = "LOCK_SUCCESS";
    SystemStatus["M_COMPARE_CALCULATION_FAILED"] = "M_COMPARE_CALCULATION_FAILED";
    SystemStatus["M_COMPARE_CALCULATION_SUCCESS"] = "M_COMPARE_CALCULATION_SUCCESS";
    SystemStatus["ORDER_FAILED"] = "ORDER_FAILED";
    SystemStatus["ORDER_SUCCESS"] = "ORDER_SUCCESS";
    SystemStatus["POST_PROCESS_FAILED"] = "POST_PROCESS_FAILED";
    SystemStatus["POST_PROCESS_SUCCESS"] = "POST_PROCESS_SUCCESS";
    SystemStatus["PRICE_CALCULATION_FAILED"] = "PRICE_CALCULATION_FAILED";
    SystemStatus["PRICE_CALCULATION_SUCCESS"] = "PRICE_CALCULATION_SUCCESS";
    SystemStatus["RATING_CALCULATION_FAILED"] = "RATING_CALCULATION_FAILED";
    SystemStatus["RATING_CALCULATION_SUCCESS"] = "RATING_CALCULATION_SUCCESS";
    SystemStatus["SOUND_FAILED"] = "SOUND_FAILED";
    SystemStatus["SOUND_SUCCESS"] = "SOUND_SUCCESS";
    SystemStatus["VALIDATE_CONFIGURATION_FAILED"] = "VALIDATE_CONFIGURATION_FAILED";
    SystemStatus["VALIDATE_CONFIGURATION_SUCCESS"] = "VALIDATE_CONFIGURATION_SUCCESS";
    SystemStatus["VALIDATE_DESIGN_FAILED"] = "VALIDATE_DESIGN_FAILED";
    SystemStatus["VALIDATE_DESIGN_SUCCESS"] = "VALIDATE_DESIGN_SUCCESS";
    SystemStatus["VALIDATE_FINAL_FAILED"] = "VALIDATE_FINAL_FAILED";
    SystemStatus["VALIDATE_FINAL_SUCCESS"] = "VALIDATE_FINAL_SUCCESS";
    SystemStatus["VALIDATE_M_COMPARE_FAILED"] = "VALIDATE_M_COMPARE_FAILED";
    SystemStatus["VALIDATE_M_COMPARE_SUCCESS"] = "VALIDATE_M_COMPARE_SUCCESS";
})(SystemStatus || (exports.SystemStatus = SystemStatus = {}));
/** System type status type */
var SystemTypeStatus;
(function (SystemTypeStatus) {
    SystemTypeStatus["CLOSED"] = "CLOSED";
    SystemTypeStatus["DEAD_AND_BURIED"] = "DEAD_AND_BURIED";
    SystemTypeStatus["DELETE"] = "DELETE";
    SystemTypeStatus["DEVELOP"] = "DEVELOP";
    SystemTypeStatus["PRODUCTION"] = "PRODUCTION";
    SystemTypeStatus["RETIRED"] = "RETIRED";
})(SystemTypeStatus || (exports.SystemTypeStatus = SystemTypeStatus = {}));
/** Search scope */
var TotalCostOfOwnershipdSearchScope;
(function (TotalCostOfOwnershipdSearchScope) {
    TotalCostOfOwnershipdSearchScope["ALL"] = "ALL";
    TotalCostOfOwnershipdSearchScope["MY"] = "MY";
})(TotalCostOfOwnershipdSearchScope || (exports.TotalCostOfOwnershipdSearchScope = TotalCostOfOwnershipdSearchScope = {}));
/** VariantDataType */
var VariantDataType;
(function (VariantDataType) {
    VariantDataType["EXACTLY_ONE"] = "EXACTLY_ONE";
    VariantDataType["ONE_OR_MORE"] = "ONE_OR_MORE";
    VariantDataType["ONE_OR_ZERO"] = "ONE_OR_ZERO";
    VariantDataType["UNDEFINED"] = "UNDEFINED";
    VariantDataType["ZERO_OR_MORE"] = "ZERO_OR_MORE";
})(VariantDataType || (exports.VariantDataType = VariantDataType = {}));
/** Response code from build request */
var WiringDiagramBuildResponseCodeEnum;
(function (WiringDiagramBuildResponseCodeEnum) {
    WiringDiagramBuildResponseCodeEnum["ALREADY_BUILDING"] = "ALREADY_BUILDING";
    WiringDiagramBuildResponseCodeEnum["BUILDING"] = "BUILDING";
    WiringDiagramBuildResponseCodeEnum["EXCEPTION"] = "EXCEPTION";
    WiringDiagramBuildResponseCodeEnum["INVALID_GENESYS_ID"] = "INVALID_GENESYS_ID";
    WiringDiagramBuildResponseCodeEnum["INVALID_USER"] = "INVALID_USER";
    WiringDiagramBuildResponseCodeEnum["NOT_LOCKED"] = "NOT_LOCKED";
    WiringDiagramBuildResponseCodeEnum["SERVER_ERROR"] = "SERVER_ERROR";
    WiringDiagramBuildResponseCodeEnum["SYSTEM_NOT_SUPPORTED"] = "SYSTEM_NOT_SUPPORTED";
    WiringDiagramBuildResponseCodeEnum["UNABLE_TO_PARSE"] = "UNABLE_TO_PARSE";
    WiringDiagramBuildResponseCodeEnum["UNAUTHORIZED"] = "UNAUTHORIZED";
    WiringDiagramBuildResponseCodeEnum["UNSPECIFIED_ERROR"] = "UNSPECIFIED_ERROR";
})(WiringDiagramBuildResponseCodeEnum || (exports.WiringDiagramBuildResponseCodeEnum = WiringDiagramBuildResponseCodeEnum = {}));
/** Response code from check state request */
var WiringDiagramCheckStateResponseCodeEnum;
(function (WiringDiagramCheckStateResponseCodeEnum) {
    WiringDiagramCheckStateResponseCodeEnum["BUILDING"] = "BUILDING";
    WiringDiagramCheckStateResponseCodeEnum["BUILT"] = "BUILT";
    WiringDiagramCheckStateResponseCodeEnum["CUSTOM_ERROR"] = "CUSTOM_ERROR";
    WiringDiagramCheckStateResponseCodeEnum["EXCEPTION"] = "EXCEPTION";
    WiringDiagramCheckStateResponseCodeEnum["INVALID_GENESYS_ID"] = "INVALID_GENESYS_ID";
    WiringDiagramCheckStateResponseCodeEnum["NOT_DESIGNED"] = "NOT_DESIGNED";
    WiringDiagramCheckStateResponseCodeEnum["SERVER_ERROR"] = "SERVER_ERROR";
    WiringDiagramCheckStateResponseCodeEnum["UNAUTHORIZED"] = "UNAUTHORIZED";
    WiringDiagramCheckStateResponseCodeEnum["UNSPECIFIED_ERROR"] = "UNSPECIFIED_ERROR";
})(WiringDiagramCheckStateResponseCodeEnum || (exports.WiringDiagramCheckStateResponseCodeEnum = WiringDiagramCheckStateResponseCodeEnum = {}));
/** Response code from download request */
var WiringDiagramDownloadResponseCodeEnum;
(function (WiringDiagramDownloadResponseCodeEnum) {
    WiringDiagramDownloadResponseCodeEnum["EXCEPTION"] = "EXCEPTION";
    WiringDiagramDownloadResponseCodeEnum["INVALID_GENESYS_ID"] = "INVALID_GENESYS_ID";
    WiringDiagramDownloadResponseCodeEnum["NOT_FOUND"] = "NOT_FOUND";
    WiringDiagramDownloadResponseCodeEnum["OK"] = "OK";
    WiringDiagramDownloadResponseCodeEnum["SERVER_ERROR"] = "SERVER_ERROR";
    WiringDiagramDownloadResponseCodeEnum["UNAUTHORIZED"] = "UNAUTHORIZED";
    WiringDiagramDownloadResponseCodeEnum["UNSPECIFIED_ERROR"] = "UNSPECIFIED_ERROR";
})(WiringDiagramDownloadResponseCodeEnum || (exports.WiringDiagramDownloadResponseCodeEnum = WiringDiagramDownloadResponseCodeEnum = {}));
//# sourceMappingURL=index.js.map